import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { ActivateStreamingBundleOfferTypeEnum } from '../../enums/streaming-bundles/activate-streaming-bundle-offer-type.enum';
var ActivateStreamingBundleUtil = /** @class */ (function () {
    function ActivateStreamingBundleUtil() {
    }
    ActivateStreamingBundleUtil.createRequest = function (basket) {
        var request = {
            offers: [
                {
                    id: OmapiIdsUtils.STREAMING_BUNDLE,
                    type: ActivateStreamingBundleOfferTypeEnum.BUNDLE,
                    offers: [
                        {
                            id: basket.selectedTvShopEntertainmentPack.omapiId,
                            type: ActivateStreamingBundleOfferTypeEnum.OPTION
                        }
                    ]
                }
            ],
            installation: {
                location: {
                    id: basket.locationId
                }
            }
        };
        if (basket.selectStreamingServiceOption) {
            // @TODO: We need to replace omapiId in streamingPacks with omapiid as there is a discrepancy between what we get from api and the model and it is breaking
            var omapiId = basket.selectStreamingServiceOption.omapiid ? basket.selectStreamingServiceOption.omapiid : basket.selectStreamingServiceOption['omapiId'];
            Object.assign(request.offers[0].offers[0], request.offers[0].offers[0], {
                offers: [
                    {
                        id: omapiId,
                        type: ActivateStreamingBundleOfferTypeEnum.OPTION
                    }
                ]
            });
        }
        return request;
    };
    ActivateStreamingBundleUtil.createFeasibilityRequest = function (salesOrder) {
        return { customerId: salesOrder.customerId };
    };
    return ActivateStreamingBundleUtil;
}());
export { ActivateStreamingBundleUtil };
